import React__default from 'react';
import { Collapse, List, ListItem, ListItemText, Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import KButton from '../../KButtons/index.js';
import SanitizeHtml from '../../SanitizeHtml/index.js';
import { classes } from './index.styled.js';

var DownloadManagerCSUList = function (_a) {
    var visible = _a.visible, content = _a.content, setVisibility = _a.setVisibility, id = _a.id, className = _a.className, sx = _a.sx, _b = _a.testId, testId = _b === void 0 ? "DownloadManagerCSUList" : _b;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Collapse, { "data-testid": testId, sx: sx, id: id, className: clsx("DownloadManagerCSUList", className, visible && "DownloadManagerCSUList-visible"), "in": visible },
        React__default.createElement(List, { className: classes.list }, content === null || content === void 0 ? void 0 : content.map(function (_a) {
            var elementId = _a.elementId, elementTitle = _a.elementTitle, terms = _a.terms;
            return (React__default.createElement(ListItem, { className: classes.listItem, key: elementId },
                React__default.createElement(ListItemText, { className: classes.listItemText, primary: React__default.createElement(Typography, { className: classes["break"], variant: "subtitle1" },
                        elementId,
                        " - ",
                        elementTitle) }),
                React__default.createElement(List, { className: classes.listNested, disablePadding: true }, terms.map(function (_a, i) {
                    var name = _a.name, value = _a.value;
                    return (React__default.createElement(ListItem, { key: "".concat(name).concat(i), className: classes.listItemNested, disableGutters: true },
                        React__default.createElement(ListItemText, { className: classes.listItemTextNested, primary: React__default.createElement(Typography, { className: classes["break"], variant: "overline" }, name), secondary: React__default.createElement(SanitizeHtml, { html: value, className: classes["break"] }) })));
                }))));
        })),
        React__default.createElement(KButton, { className: classes.close, fullWidth: true, onClick: function () { return setVisibility(false); } }, t("components.DownloadManagerCSU.actions.close"))));
};

export { DownloadManagerCSUList as default };
//# sourceMappingURL=DownloadManagerCSUList.js.map
